/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Notify_TitleInputs */

const en_fw_notify_title = /** @type {(inputs: Fw_Notify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

const id_fw_notify_title = /** @type {(inputs: Fw_Notify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Fw_Notify_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_notify_title = /** @type {((inputs?: Fw_Notify_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Notify_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_notify_title(inputs)
	return en_fw_notify_title(inputs)
});